import './ProfileName.scss';

const ProfileName = ({firstName, lastName, email}) => {

    return (
        <div className={"profile-card-name"}>
            <div className={"profile-card-name_container"}>
                <div className={"profile-card-name_container_title"}>
                    <div className={"profile-card-name_container_first-name"}>
                        {firstName}
                    </div>
                    <div className={"profile-card-name_container_last-name"}>
                        {lastName}
                    </div>
                </div>
                <div className={"profile-card-name_container_email"}>
                    {email}
                </div>
            </div>
        </div>
    )
}

export default ProfileName;